import { BaleStatusEnum, BaleTypeEnum, QualityTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { BaleItems } from "./bale-items.entity";

@Entity('bale_info')
export class BaleInfo {

    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @Column('varchar',{
        name:'bale_no',
        length:30,
        nullable:false
    })
    baleNo: string

    @Column('datetime',{
        name:'bale_date',
        nullable:false
    })
    baleDate : Date

    @Column('enum',{
        name:'type',
        enum:BaleTypeEnum,
        nullable:false
    })
    type : BaleTypeEnum

    @Column('decimal',{
        name:'quantity',
        precision:10,scale:3,
        nullable:false
    })
    quantity : number

    @Column('enum',{
        name:'status',
        enum:BaleStatusEnum,
        nullable:false
    })
    status : BaleStatusEnum

    @Column('int',{
        name:'ref_no',
        nullable:false
    })
    refNo : number

    @Column('int',{
        name:'plant_id',
        nullable:false
    })
    plantId : number

    @Column('decimal',{
        name:'actual_bale_qty',
        nullable:false,
        precision:10,scale:3,
    })
    actualbaleQty : number

    @Column('decimal',{
        name:'tare_qty',
        nullable:false,
        precision:10,scale:3,
    })
    tareQty : number

    @Column('decimal',{
        name:'gross_qty',
        nullable:false,
        precision:10,scale:3,
    })
    grossQty : number

    @Column('int',{
        name:'variant_id',
        nullable:false,
    })
    variantId : number

    @Column('decimal',{
        name:'work_order_qty',
        precision:10,scale:3,
        nullable:false
    })
    workOrderQty : number

    @Column('enum',{
        name:'quality',
        nullable:true,
        enum:QualityTypeEnum
    })
    quality : QualityTypeEnum


    
    @OneToMany(type => BaleItems, baleItems => baleItems.baleInfo, { cascade: true })
    baleItemsInfo: BaleItems[];
}